import { Dropdown, Icon, IconType } from '@lmc/ui-kit'
import React, { type CSSProperties, type ReactElement } from 'react'

type Props = {
  popOver?: ReactElement
  state?: 'signed' | 'unsigned' | 'archived' | 'refused'
  testId?: string
}

const ListItemRightChildrenNew = ({ popOver, state, testId }: Props) => {
  if (state === 'archived') {
    return (
      <Icon
        customIcon={IconType.Other}
        style={{ ...styles.otherIcon, ...styles.archived } as CSSProperties}
      />
    )
  }

  return (
    <div onClick={(e) => e.stopPropagation()} data-testid={testId}>
      <Dropdown
        overlay={<div>{popOver}</div>}
        placement="bottomRight"
        trigger={['click']}
      >
        <Icon
          customIcon={IconType.Other}
          style={styles.otherIcon as CSSProperties}
        />
      </Dropdown>
    </div>
  )
}

const styles = {
  archived: {
    cursor: 'default'
  },
  otherIcon: {
    float: 'right',
    cursor: 'pointer',
    marginLeft: 16,
    width: 20,
    height: 20
  }
}

export default ListItemRightChildrenNew
